import { render, staticRenderFns } from "./ContactFormSubmitted.vue?vue&type=template&id=9ebff3d6&"
import script from "./ContactFormSubmitted.vue?vue&type=script&lang=js&"
export * from "./ContactFormSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports